import { useMemo } from 'react';
import { buildGraph, entityLabel, isSelectable, type MapGraph } from '@quadro/domain';
import { useFileMap, useLiveMap } from '../../data/queries';
import type { MapSource } from '../../data/api';
import { useUI } from '../../state/ui';

/** Mapa societário ativo (ao vivo do banco ou arquivo importado) e seu grafo. */
export function useMapSource(): { source: MapSource | null; graph: MapGraph | null; loading: boolean; error: Error | null } {
  const pref = useUI(s => s.map.source);
  const file = useFileMap();
  const live = useLiveMap(pref === 'live' || (!file.isPending && !file.data));
  const source = pref === 'file' && file.data ? file.data : live.data ?? file.data ?? null;
  const graph = useMemo(() => (source ? buildGraph(source.data) : null), [source]);
  return { source, graph, loading: !source && (live.isPending || file.isPending), error: (!source && (live.error || file.error)) || null };
}

/** Entidades que podem ser ligadas a tarefas (para captura e seletores). */
export function useEntities() {
  const { graph } = useMapSource();
  return useMemo(() => {
    const nodes = graph ? graph.data.nos.filter(isSelectable) : [];
    const byId = new Map(nodes.map(n => [n.id, n]));
    return {
      graph,
      list: nodes,
      name: (id: string) => { const n = byId.get(id); return n ? entityLabel(n) : graph ? 'Entidade fora do mapa' : 'Entidade'; },
      exists: (id: string) => byId.has(id),
    };
  }, [graph]);
}
